import { ProductPriceResponse } from '../../types/product'
import { getDefaultVariant, getEffectivePrice } from '../../utils/cartUtils'

/** Shape returned by GET /user/liked (ProductPublicResponse). */
export interface LikedApiProduct {
  id: string
  name?: string
  slug?: string
  description?: string
  mainPicture?: string
  beanType?: { label: string; value: string }
  originCountry?: string
  originRegion?: string
  prices?: ProductPriceResponse[]
  variants?: Array<{ label: string; value: string }>
  tags?: Array<string | { name: string; value?: string }>
}

export interface WishlistMappedItem {
  id: string
  name: string
  price: number
  mainPicture?: string
  slug: string
  description?: string
  beanType?: { label: string; value: string }
  originCountry?: string
  originRegion?: string
  prices?: ProductPriceResponse[]
  variants?: Array<{ label: string; value: string }>
  tags?: string[]
}

/**
 * Maps a liked-product API payload into the wishlist store shape.
 * Prices live in `prices[]` (no top-level `price` on the public product DTO).
 */
export function mapLikedApiProductToWishlistItem(item: LikedApiProduct): WishlistMappedItem {
  const prices = item.prices || []
  const defaultVariant = getDefaultVariant(prices)

  return {
    id: item.id,
    name: item.name || 'Unknown Product',
    price: defaultVariant ? getEffectivePrice(defaultVariant) : 0,
    mainPicture: item.mainPicture || '',
    slug: item.slug || item.id,
    description: item.description || '',
    beanType: item.beanType,
    originCountry: item.originCountry,
    originRegion: item.originRegion,
    prices,
    variants: item.variants,
    tags: item.tags?.map(tag => (typeof tag === 'string' ? tag : tag.name)) || undefined,
  }
}
